import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as postActions from '../../../store/action/post'
import 'react-toastify/dist/ReactToastify.css';
import { renderFormField, renderTextAreaField, renderKeywordField } from 'src/utils/reduxField';
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import { validateCreatePostForm } from './../../../utils/formValidation'
import localStorage from '../../../utils/local-storage'
import moment from 'moment'
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import slugify from '@sindresorhus/slugify';
import localStore from 'src/utils/local-storage';
const AI_URL = process.env.REACT_APP_URL_AI;
import fetchAiRecommend from "../../../utils/AiRecommend.jsx";
import countWordsHTML from 'src/utils/countWordsHTML';

const validate = values => {
  return validateCreatePostForm(values, false);
};

class TitleTab extends Component {
  constructor() {
    super();
    const aiLimitWords = localStore.get("_aiLimitWord");
    this.state = {
      canChangeUrl: true,
      error: true,
      editableUrl: true,
      listPostSame: [],
      timer: null,
      show: false,
      suggestedTitles: [],
      isLoading: false,
      content: '',
      lengthContent: (aiLimitWords && aiLimitWords.content) ? aiLimitWords.content : 200,
      showNoContentModal: false,
      titleGoogleError: false,
      titleGoogleHighlight: false,
      titleHighlight: false
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { post: { currentPost }, config: nextConfig } = nextProps || this.props;
    let { content, lengthContent } = this.state
    if(currentPost.content && countWordsHTML(currentPost.content) >= lengthContent){
      this.setState({
        content : currentPost.content, 
      });
    } else {
      this.setState({
        content: ''
      })
    }

    // this.getData(nextProps);
  }

  getData(props) {
       
  }

  componentDidUpdate(prevProps) {
    const { fields } = this.props;
    const { fields: prevFields } = prevProps;
    if(fields && prevFields){
      if (fields.title !== prevFields.title) {
        this.updateFieldData(fields, 'title', 'title_search');
      }
      if (fields.url !== prevFields.url) {
        this.updateFieldData(fields, 'url');
      }
      if (fields.keyword !== prevFields.keyword) {
        this.updateFieldData(fields, 'keyword');
      }
      if (fields.title_google !== prevFields.title_google) {
        this.updateFieldData(fields, 'title_google', 'url');
        this.setState({
          titleGoogleError: fields.title_google && fields.title_google.length > 70
        });
      }
      
    }
  }
  componentDidMount(props) {
    // console.log("mount");
    // console.log(props);
  }
  componentWillUnmount(props) {
    // console.log("unmount2");
    // console.log(props);
  }
  updateFieldData = (data, fieldName, slugifyField = null) => {
    // console.log(data);
    this.state.timer && clearTimeout(this.state.timer);

    const { post } = this.props;

    const timer = setTimeout(() => {
      post.currentPost[fieldName] = data[fieldName];
      if (slugifyField && fieldName && data[fieldName]) {
        const slugifyValue = slugify(data[fieldName]);
        if(!post.currentPost['changeslug']){
          post.currentPost[slugifyField] = slugifyValue;
          this.props.changeFieldValue(slugifyField, slugifyValue);
        }
      }
      this.props.setCurrentPost(post.currentPost);
    }, 100);

    this.setState({ timer });
  }

  genePostUrl() {

    const { post: { currentPost } } = this.props
    // console.log(currentPost.categories);
    const _user = localStorage.get('_user')
    if(currentPost){
      let url = "/";
      if (currentPost.primary_category) {
        url += currentPost.primary_category.url + '/';
      }
      if (currentPost.url) {
        url += currentPost.url + '-';
      }
      url += moment().format('YYYYMMDDhmmss');
      // url += _user.increment_id || _user._id;
      // console.log(url);

      return url;
    }
    return null;
  }

  changeEditableState = (value) => {
    const { post } = this.props;
    this.setState({ editableUrl: !value });
    if(this.state.editableUrl){
      post.currentPost['changeslug'] = true;
      this.props.setCurrentPost(post.currentPost);
    }
  }

  handleClose = () => {
    this.setState({ show: false, showNoContentModal: false });
  }
  openModalEdit = (data) => {
    this.actionForModal(true, data);
  }
  openModalCreate = (data) => {
    this.actionForModal(true, "");
  }

  actionForModal = (status, editId) => {
    let { postLists } = this.state
    // postLists = _.filter(postLists, (pst) => {
    //   // pst.posttype.type_code == 'ready' && 
    //   return !this.checkInList(pst._id)
    // });
    // console.log(status);
    // console.log(postLists);
    this.setState({ show: status, editId: editId, postLists })
  }

  strip_tags(input, allowed) {
    allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
    const tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
    return input.replace(tags, ($0, $1) => (allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''))
  }


  checkTitle = async () => {
    const { post: { currentPost } } = this.props;
    const content = currentPost.content;
    const wordCount = countWordsHTML(content);

    if (!content || wordCount < 200) {
      this.setState({ showNoContentModal: true });
      return;
    }

    if (this.state.suggestedTitles.length === 0) {
      this.setState({ isLoading: true });
      this.setState({ show: true });
      const response = await fetchAiRecommend(content, 'title-recommendation');
      this.setState({
        suggestedTitles: response.titles,
        isLoading: false
      });
    } else {
      this.setState({ show: true });
    }
  }

  reloadTitles = async () => {
    const { post: { currentPost } } = this.props;
    const content = currentPost.content;
    const wordCount = countWordsHTML(content);

    if (!content || wordCount < 200) {
      this.setState({ showNoContentModal: true });
      return;
    }

    this.setState({ isLoading: true });
    const response = await fetchAiRecommend(content, 'title-recommendation');
    this.setState({
      suggestedTitles: response.titles,
      isLoading: false
    });
  }

  selectTitle = (title) => {
    this.props.changeFieldValue('title', title);
    this.handleClose();
    this.setState({
      titleHighlight: true
    });

    setTimeout(() => {
      this.setState({ titleHighlight: false });
    }, 600);
  }

  copyTitle = () => {
    const { fields, changeFieldValue } = this.props;
    if (fields && fields.title) {
      changeFieldValue('title_google', fields.title);
      this.setState({
        titleGoogleError: fields.title.length > 70,
        titleGoogleHighlight: true
      });
      
      setTimeout(() => {
        this.setState({ titleGoogleHighlight: false });
      }, 600);
    }
  }

  render() {
    let { listPostSame } = this.state;
    let { layoutName, checkClass, post: { currentPost }, checkRequireData } = this.props;

    return (
      <div className={(layoutName !== 'layout-pc' ? 'row card' : '')}>
        {
          layoutName !== 'layout-pc' &&
          <div className={"d-flex align-items-center justify-content-between card-header col-12 " + (checkClass)}>
            <h4 className="card-title flex-grow-1">Tiêu đề bài viết</h4>
            <button type="button" className="btn btn-ai-recommend" onClick={this.checkTitle}>
              <span className="mr-2">
              <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" dataIcon="open-a-i" width="16px" height="16px" fill="currentColor" ariaHidden="true"><path d="M482.88 128c-84.35 0-156.58 52.8-185.68 126.98-60.89 8.13-115.3 43.63-146.6 97.84-42.16 73-32.55 161.88 17.14 224.16-23.38 56.75-19.85 121.6 11.42 175.78 42.18 73.02 124.1 109.15 202.94 97.23C419.58 898.63 477.51 928 540.12 928c84.35 0 156.58-52.8 185.68-126.98 60.89-8.13 115.3-43.62 146.6-97.84 42.16-73 32.55-161.88-17.14-224.16 23.38-56.75 19.85-121.6-11.42-175.78-42.18-73.02-124.1-109.15-202.94-97.23C603.42 157.38 545.49 128 482.88 128m0 61.54c35.6 0 68.97 13.99 94.22 37.74-1.93 1.03-3.92 1.84-5.83 2.94l-136.68 78.91a46.11 46.11 0 00-23.09 39.78l-.84 183.6-65.72-38.34V327.4c0-76 61.9-137.86 137.94-137.86m197.7 75.9c44.19 3.14 86.16 27.44 109.92 68.57 17.8 30.8 22.38 66.7 14.43 100.42-1.88-1.17-3.6-2.49-5.53-3.6l-136.73-78.91a46.23 46.23 0 00-46-.06l-159.47 91.1.36-76.02 144.5-83.41a137.19 137.19 0 0178.53-18.09m-396.92 55.4c-.07 2.2-.3 4.35-.3 6.56v157.75a46.19 46.19 0 0022.91 39.9l158.68 92.5-66.02 37.67-144.55-83.35c-65.86-38-88.47-122.53-50.45-188.34 17.78-30.78 46.55-52.69 79.73-62.68m340.4 79.93l144.54 83.35c65.86 38 88.47 122.53 50.45 188.34-17.78 30.78-46.55 52.69-79.73 62.68.07-2.19.3-4.34.3-6.55V570.85a46.19 46.19 0 00-22.9-39.9l-158.69-92.5zM511.8 464.84l54.54 31.79-.3 63.22-54.84 31.31-54.54-31.85.3-63.16zm100.54 58.65l65.72 38.35V728.6c0 76-61.9 137.86-137.94 137.86-35.6 0-68.97-13.99-94.22-37.74 1.93-1.03 3.92-1.84 5.83-2.94l136.68-78.9a46.11 46.11 0 0023.09-39.8zm-46.54 89.55l-.36 76.02-144.5 83.41c-65.85 38-150.42 15.34-188.44-50.48-17.8-30.8-22.38-66.7-14.43-100.42 1.88 1.17 3.6 2.5 5.53 3.6l136.74 78.91a46.23 46.23 0 0046 .06z"></path></svg>
              </span>
              Gợi ý AI
            </button>
          </div>
        }
        <Modal show={this.state.showNoContentModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Thông báo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Chưa có nội dung bài viết hoặc content chưa đủ {this.state.lengthContent} từ, không thể gợi ý tiêu đề</p>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Gợi ý tiêu đề</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.isLoading ? (
                <div className="ai-loading-container">
                  <div className="ai-icon-container">
                      <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" dataIcon="open-a-i" width="32px" height="32px" fill="#6366f1" ariaHidden="true" className="rotating-icon">
                          <path d="M482.88 128c-84.35 0-156.58 52.8-185.68 126.98-60.89 8.13-115.3 43.63-146.6 97.84-42.16 73-32.55 161.88 17.14 224.16-23.38 56.75-19.85 121.6 11.42 175.78 42.18 73.02 124.1 109.15 202.94 97.23C419.58 898.63 477.51 928 540.12 928c84.35 0 156.58-52.8 185.68-126.98 60.89-8.13 115.3-43.62 146.6-97.84 42.16-73 32.55-161.88-17.14-224.16 23.38-56.75 19.85-121.6-11.42-175.78-42.18-73.02-124.1-109.15-202.94-97.23C603.42 157.38 545.49 128 482.88 128m0 61.54c35.6 0 68.97 13.99 94.22 37.74-1.93 1.03-3.92 1.84-5.83 2.94l-136.68 78.91a46.11 46.11 0 00-23.09 39.78l-.84 183.6-65.72-38.34V327.4c0-76 61.9-137.86 137.94-137.86m197.7 75.9c44.19 3.14 86.16 27.44 109.92 68.57 17.8 30.8 22.38 66.7 14.43 100.42-1.88-1.17-3.6-2.49-5.53-3.6l-136.73-78.91a46.23 46.23 0 00-46-.06l-159.47 91.1.36-76.02 144.5-83.41a137.19 137.19 0 0178.53-18.09m-396.92 55.4c-.07 2.2-.3 4.35-.3 6.56v157.75a46.19 46.19 0 0022.91 39.9l158.68 92.5-66.02 37.67-144.55-83.35c-65.86-38-88.47-122.53-50.45-188.34 17.78-30.78 46.55-52.69 79.73-62.68m340.4 79.93l144.54 83.35c65.86 38 88.47 122.53 50.45 188.34-17.78 30.78-46.55 52.69-79.73 62.68.07-2.19.3-4.34.3-6.55V570.85a46.19 46.19 0 00-22.9-39.9l-158.69-92.5zM511.8 464.84l54.54 31.79-.3 63.22-54.84 31.31-54.54-31.85.3-63.16zm100.54 58.65l65.72 38.35V728.6c0 76-61.9 137.86-137.94 137.86-35.6 0-68.97-13.99-94.22-37.74 1.93-1.03 3.92-1.84 5.83-2.94l136.68-78.9a46.11 46.11 0 0023.09-39.8zm-46.54 89.55l-.36 76.02-144.5 83.41c-65.85 38-150.42 15.34-188.44-50.48-17.8-30.8-22.38-66.7-14.43-100.42 1.88 1.17 3.6 2.5 5.53 3.6l136.74 78.91a46.23 46.23 0 0046 .06z"></path>
                      </svg>
                      <div className="pulse-ring">                                   
                      </div>                                
                  </div>
                  <div className="loading-text">
                      <div className="d-flex align-items-center">AI đang phân tích
                          <div className="loading-dots" style={{ marginLeft: '10px' }}>
                              <span>•</span>
                              <span>•</span>
                              <span>•</span>
                          </div>
                      </div>
                  </div>                            
              </div>
            )
            :
            <>
              <table className="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th style={{ width: "10px" }}></th>
                    <th>Tiêu đề gợi ý</th>
                    <th style={{ width: "100px" }}>Chọn</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.suggestedTitles.map((title, idx) => (
                    <tr key={`suggestion-${idx}`}>
                      <td>{idx + 1}.</td>
                      <td>{title}</td>
                      <td>
                        <button 
                          className="btn btn-sm btn-primary"
                          onClick={() => this.selectTitle(title)}
                        >
                          Chọn
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-center mt-5">
                  <button className="btn btn-ai-recommend" onClick={this.reloadTitles}>
                    Gợi ý khác <i className="fas fa-sync ml-2"></i>
                  </button>
              </div>
            </>
            }
          </Modal.Body>
        </Modal>
        <div className="card-body col-12">
          <Field
            keys="title"
            classinput={`form-control ${this.state.titleHighlight ? 'highlight-border' : ''}`}
            classgroup="form-group"
            id="titleInput"
            style={{ resize: "none" }}
            name="title"
            type="text"
            component={renderTextAreaField}
            label="Tiêu đề bài viết"
            readonly={this.props.readonly}
          />
          <button className="btn btn-sm btn-primary mb-2" onClick={this.copyTitle}>
            Lấy tiêu đề
          </button>
          <Field keys="title_google" 
                 classinput={`form-control ${this.state.titleGoogleHighlight ? 'highlight-border' : ''}`}
                 classgroup="form-group"
                 id="titlegoogleInput"
                 name="title_google" 
                 type="text" 
                 component={renderTextAreaField}
                 label="Tiêu đề bài viết hiển thị trên google (độ dài tối đa 70 ký tự)"
                 readonly={this.props.readonly} 
                 maxLength="70"
                 onBlur={(event, newValue, previousValue, name) => {
                   checkRequireData(currentPost || '', 16);
                 }}
          />          
          {this.state.titleGoogleError && 
            <div className="text-danger mb-2" style={{fontSize: '12px', marginTop: '-8px'}}>Tiêu đề google đã vượt quá 70 kí tự</div>
          }

          <div className="position-relative">
            <div
              onClick={e => this.changeEditableState(this.state.editableUrl)}
              style={{
                color: '#007bff',
                cursor: 'pointer',
                position: 'absolute',
                right: '0',
                top: '0'
              }}
              className={this.state.editableUrl ? 'active' : ''}
            >
              {this.state.editableUrl ? 'Sửa' : 'OK'}
            </div>
            <Field keys="url" classinput="form-control" classgroup="form-group" id="urlInput"
              name="url" type="text" component={renderFormField} label="Url" readonly={this.state.editableUrl} />
          </div>
          <Field keys="keyword"
                 id="keywordInput"
                 classinput="form-control"
                 classgroup="form-group"
                 name="keyword"
                 type="text"
                 label="Keyword (Tối đa 35 ký tự)"
                 component={renderKeywordField}
                 readonly={this.props.readonly}
                 maxLength="35"
                 onBlur={(event, newValue, previousValue, name) => {
                    checkRequireData(currentPost || '', 18);
                 }}
          />
        </div>        
      </div>
    )
  }

};
const selector = formValueSelector('formPostEdit');

TitleTab = reduxForm({
  form: 'formPostEdit',
  validate,
  asyncBlurFields: ['title', 'title_google']
})(TitleTab)

export default connect(store => {
  return {
    post: store.post,
    form: store.formPostEdit,
    fields: selector(store, 'title', 'title_google', 'url', 'keyword')
  };
}, dispatch => {
  return {
    setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
    changeFieldValue: (field, value) => { dispatch(change('formPostEdit', field, value)) },
  }
})(TitleTab)